import { RpoToolService } from './../../services/rpo-tool.service';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'src/app/shared/services/toast.service';
import * as constants from 'src/app/config/app-constants';
import { Image } from '../../models/drug-details';
import {  DropDownTwo } from '../../models/dropdown';
import { AddDrugImage, ImageModel } from './../../models/add-image';
import { ImportWizardAlertComponent } from '../import-wizard-alert/import-wizard-alert.component';

interface RpoImageMetadata {
  width: number;
  height: number;
  horizontalDpi: number | null;
  verticalDpi: number | null;
  bitDepth: number | null;
}



@Component({
    selector: 'app-import-wizard-image-slide',
    templateUrl: './import-wizard-image-slide.component.html',
    styleUrls: ['./import-wizard-image-slide.component.scss'],
    standalone: false
})
export class ImportWizardImageSlideComponent implements OnInit {
  listOfDataSource: DropDownTwo[];
  
  addImage: string = null;
  images:ImageModel[]=[];
  defaultImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAAB5CAMAAAAqJH57AAAAMFBMVEX///+/v7+9vb26urrl5eXHx8fw8PDz8/PNzc3q6urCwsL5+fn8/Pzi4uLa2trW1tZO13xoAAACCUlEQVRoge3Z23aDIBAFUBlUEJH8/9/WS1UQSuMwpCvNnLd2me4KByXaNBwOh8N549iaycGthIrpsrKoGJZZ/nsZJGXghqwVZSa4IWeOuZ9Bsswyyyx/qGzHMbuBqyVbZ+Y7zkO9XB7N+muA4dVyt99gZf9a+dyowC/NsxOtrMWZ/FQ7SNYQK1tzwpAdbiVlsgnVZash/cdJRnvMfNjNRZSpA2o3rF+PeFDKjd5XVa5gtluPMImO4WXbbVcSkZtlt/17sqWUm2bSxnQuN8n9PiyJCal7xzgXQDwjpHdJdWnSdLYw7hiprGUAqKODc8eiSaGUWxAB3XlLPu4YoTwus+rRzjvlxIcJ5QcEM9oHsIgWH508fEvg1h+tDuWoY3TyMasb7S6nHF3dyeTplBZaXV0Blw1CkTyc14fRf5YiXdBrkSRK5Pl2cIxgOKugo7GO9mslcguwXyAGGUvRcIcdK5GX9QvrgPs7lEyCjhXI7TqiZqHjIqcig44VyNt5wkyrp+ALgpeP7ZBRqT4lT9rvWMF3jOc0P0HHCHaAd+J1DC0/1+ZL/I5hZeTzX49ByhYxy0u8r7xIGfvI2+sYTsaesvA6hpMn9Bss6crkoUXnmOg3fSrFMsv/RO7wqzgRd+NNmaB81Q533g7WCcsss8wyyyyzzDLLLLP8eXLNmIw89lWTkTkcDofD+SlfIsYv/LXKcNQAAAAASUVORK5CYII=';
  selectedImageTypeId: number = 1;
  fileChangeEvent: any | null = null;
  fielName = '';
  fieleSelect = false;
  isEmptyImage : boolean = false;
  blobName: string = '';
  private readonly rpoImageRequirements = {
    width: 386,
    height: 257,
    horizontalDpi: 96,
    verticalDpi: 96,
    bitDepth: 24
  };
  private readonly rpoImageMaxSizeBytes = 100 * 1024;
  private readonly rpoImageValidationMessage =
    'Invalid image format. Required: 386 x 257 (W x H), 96 DPI horizontal, 96 DPI vertical, 24-bit color depth.';
  private selectedImageMetadata: RpoImageMetadata | null = null;
  
  imageTypes = [
    { id: 1, name: 'Front' },
    { id: 2, name: 'Side' },
    { id: 3, name: 'Top' },
    { id: 4, name: 'Back' },
    { id: 5, name: 'Package' }
  ];
  constructor( public dialogRef: MatDialogRef<ImportWizardImageSlideComponent>,
    public dialog: MatDialog,
    public rpoService:RpoToolService,
    private ngxLoader: NgxUiLoaderService,
    private toastService: ToastService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
      this.ndc= data.ndc
      this.dataSource = data.dataSource
      this.isEdit = data.editPage
      this.drugId = data.drugId
    }
    ndc:string;
    dataSource:number = 1;
    isEdit:boolean = false;
    drugId:number=0;
    ngOnInit(): void {
    this.getSliderImage();
    this.loadAdditionalData();
  }

  currentIndex:number = 0;
  forwardButtonLength = 0
  slides:Image[]=[];
  selectedFile: File = null;
  slideShow(value:boolean){
    if(value==true){
      this.currentIndex++;
    }
    else if(value==false){
      this.currentIndex--;
    }
  }

  async onFileSelected(event: any) {
    this.fileChangeEvent = event;
    const file = this.getImageFileFromEvent(event);
    if (!file) {
      return;
    }
    this.selectedFile = <File>file;
    this.fielName = this.selectedFile.name;
    this.fieleSelect = true;
    await this.prepareFile(this.selectedImageTypeId);
  }


 
  selectedFileRemove() {
    this.addImage = null;
    this.fielName = '';
    this.fieleSelect = false;
    this.selectedImageTypeId=1;
    this.selectedImageMetadata = null;
    this.images = [];
    if (this.fileChangeEvent?.target) {
      this.fileChangeEvent.target.value = '';
    }
  }

  addNewImage(){
    if (!this.selectedImageMetadata || !this.isValidRpoImageMetadata(this.selectedImageMetadata)) {
      this.toastService.openToast(
        this.rpoImageValidationMessage,
        constants.ToastPanelType.error,
        2
      );
      return;
    }

    const addDrugImage : AddDrugImage = {
      drugId : this.drugId,
      ndc : this.ndc,
      images: this.images
    }
    this.ngxLoader.start();
        this.rpoService
          .saveDrugImage(addDrugImage)
          .subscribe(
            (result) => {
              this.ngxLoader.stop();
              if (result.statusCode === 200) {
                this.toastService.openToast(
                  result.message,
                  constants.ToastPanelType.done,
                  2
                );
                this.getSliderImage();
                addDrugImage.images=[];
                this.currentIndex = 0;
                this.fieleSelect = false;
                this.fielName = '';
                this.fileChangeEvent= null;
                this.images=[];
                this.addImage = null;
                this.selectedImageMetadata = null;
              } else {
                this.toastService.openToast(
                  result.message,
                  constants.ToastPanelType.error,
                  2
                );
              }
            },
            (error: HttpErrorResponse) => {
              this.ngxLoader.stop();
              console.log(error);
              this.toastService.openToast(error.error.message === undefined ?
                'Something went wrong!!' : error.error.message,
                constants.ToastPanelType.error,
                2
              );
            }
          );
  }

  async prepareFile(imageNumber: number) {
    this.images = [];
    this.selectedImageTypeId = imageNumber;
    const file = this.getImageFileFromEvent(this.fileChangeEvent);
    if (!file) {
      return;
    }

    this.fielName = file.name;
    this.fieleSelect = true;
    const reader = new FileReader();
    const fileExtension = this.fielName.split('.').pop()?.toLowerCase();

    if (!fileExtension || !['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
      this.toastService.openToast('Invalid file format. Please select an image file (jpg, jpeg, png, gif)',
        constants.ToastPanelType.error,
        2
      );
      this.clearFileInput();
      this.selectedImageMetadata = null;
      this.images = [];
      this.addImage = null;
      return;
    }

    if (file.size > this.rpoImageMaxSizeBytes) {
      this.toastService.openToast(
        this.rpoImageValidationMessage,
        constants.ToastPanelType.error,
        2
      );
      this.clearFileInput();
      this.selectedImageMetadata = null;
      this.images = [];
      this.addImage = null;
      return;
    }

    const metadata = await this.extractImageMetadata(file);
    if (!metadata || !this.isValidRpoImageMetadata(metadata)) {
      this.toastService.openToast(
        this.rpoImageValidationMessage,
        constants.ToastPanelType.error,
        2
      );
      this.clearFileInput();
      this.selectedImageMetadata = null;
      this.images = [];
      this.addImage = null;
      return;
    }

    this.selectedImageMetadata = metadata;
    reader.readAsDataURL(file);
    reader.onload = (readerEvent: any) => {
      const splitVal = reader.result.toString().split(',');
      if (splitVal.length > 0) {

        if (imageNumber) { this.addImage = `${splitVal[1]}`; }
        const newImage : ImageModel={serialImage:this.addImage,viewId:imageNumber}
        this.images.push(newImage);
      }
    };
  }

  private getImageFileFromEvent(event: any): File | null {
    if (event?.target?.files?.length) {
      return event.target.files[0];
    }
    if (event?.dataTransfer?.files?.length) {
      return event.dataTransfer.files[0];
    }
    return null;
  }

  private clearFileInput(): void {
    if (this.fileChangeEvent?.target) {
      this.fileChangeEvent.target.value = '';
    }
  }

  private isValidRpoImageMetadata(metadata: RpoImageMetadata): boolean {
    return typeof metadata.width === 'number'
      && typeof metadata.height === 'number'
      && metadata.horizontalDpi != null
      && metadata.verticalDpi != null
      && metadata.bitDepth != null
      && metadata.width === this.rpoImageRequirements.width
      && metadata.height === this.rpoImageRequirements.height
      && metadata.horizontalDpi === this.rpoImageRequirements.horizontalDpi
      && metadata.verticalDpi === this.rpoImageRequirements.verticalDpi
      && metadata.bitDepth === this.rpoImageRequirements.bitDepth;
  }

  private getRpoImageValidationDebugMessage(metadata: RpoImageMetadata | null): string {
    if (!metadata) {
      return 'Unable to read image metadata.';
    }

    const failures = this.getRpoImageValidationFailures(metadata);
    if (failures.length === 0) {
      return '';
    }

    const horizontalDpi = metadata.horizontalDpi == null ? 'missing' : metadata.horizontalDpi;
    const verticalDpi = metadata.verticalDpi == null ? 'missing' : metadata.verticalDpi;
    const bitDepth = metadata.bitDepth == null ? 'missing' : metadata.bitDepth;

    return `Detected: ${metadata.width}x${metadata.height}, H-DPI ${horizontalDpi}, V-DPI ${verticalDpi}, Depth ${bitDepth}-bit. Failed: ${failures.join(', ')}.`;
  }

  private getRpoImageValidationFailures(metadata: RpoImageMetadata): string[] {
    const failures: string[] = [];

    if (metadata.width !== this.rpoImageRequirements.width) {
      failures.push('width');
    }
    if (metadata.height !== this.rpoImageRequirements.height) {
      failures.push('height');
    }
    if (metadata.horizontalDpi == null || metadata.horizontalDpi !== this.rpoImageRequirements.horizontalDpi) {
      failures.push('horizontal DPI');
    }
    if (metadata.verticalDpi == null || metadata.verticalDpi !== this.rpoImageRequirements.verticalDpi) {
      failures.push('vertical DPI');
    }
    if (metadata.bitDepth == null || metadata.bitDepth !== this.rpoImageRequirements.bitDepth) {
      failures.push('bit depth');
    }

    return failures;
  }

  private async extractImageMetadata(file: File): Promise<RpoImageMetadata | null> {
    try {
      const arrayBuffer = await file.arrayBuffer();
      const bytes = new Uint8Array(arrayBuffer);

      if (this.isPng(bytes)) {
        return this.parsePngMetadata(bytes);
      }

      if (this.isJpeg(bytes)) {
        return this.parseJpegMetadata(bytes);
      }

      if (this.isGif(bytes)) {
        return this.parseGifMetadata(bytes);
      }

      return null;
    } catch {
      return null;
    }
  }

  private isPng(bytes: Uint8Array): boolean {
    return bytes.length > 8
      && bytes[0] === 0x89
      && bytes[1] === 0x50
      && bytes[2] === 0x4E
      && bytes[3] === 0x47
      && bytes[4] === 0x0D
      && bytes[5] === 0x0A
      && bytes[6] === 0x1A
      && bytes[7] === 0x0A;
  }

  private isJpeg(bytes: Uint8Array): boolean {
    return bytes.length > 3 && bytes[0] === 0xFF && bytes[1] === 0xD8;
  }

  private isGif(bytes: Uint8Array): boolean {
    return bytes.length > 10
      && bytes[0] === 0x47
      && bytes[1] === 0x49
      && bytes[2] === 0x46
      && bytes[3] === 0x38
      && (bytes[4] === 0x37 || bytes[4] === 0x39)
      && bytes[5] === 0x61;
  }

  private parsePngMetadata(bytes: Uint8Array): RpoImageMetadata | null {
    if (bytes.length < 33) {
      return null;
    }

    const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const width = view.getUint32(16, false);
    const height = view.getUint32(20, false);
    const bitDepthPerChannel = bytes[24];
    const colorType = bytes[25];

    const channelMap: { [key: number]: number } = {
      0: 1,
      2: 3,
      3: 1,
      4: 2,
      6: 4
    };
    const channels = channelMap[colorType];
    const bitDepth = channels ? bitDepthPerChannel * channels : null;

    let horizontalDpi: number | null = null;
    let verticalDpi: number | null = null;

    let position = 8;
    while (position + 8 <= bytes.length) {
      const chunkLength = view.getUint32(position, false);
      const chunkType = String.fromCharCode(
        bytes[position + 4],
        bytes[position + 5],
        bytes[position + 6],
        bytes[position + 7]
      );
      const dataStart = position + 8;
      const dataEnd = dataStart + chunkLength;

      if (dataEnd > bytes.length) {
        break;
      }

      if (chunkType === 'pHYs' && chunkLength >= 9) {
        const pixelsPerUnitX = view.getUint32(dataStart, false);
        const pixelsPerUnitY = view.getUint32(dataStart + 4, false);
        const unitSpecifier = bytes[dataStart + 8];
        if (unitSpecifier === 1) {
          horizontalDpi = Math.round(pixelsPerUnitX * 0.0254);
          verticalDpi = Math.round(pixelsPerUnitY * 0.0254);
        }
      }

      position = dataEnd + 4;
    }

    return {
      width,
      height,
      horizontalDpi,
      verticalDpi,
      bitDepth
    };
  }

  private parseJpegMetadata(bytes: Uint8Array): RpoImageMetadata | null {
    const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    let position = 2;

    let width: number | null = null;
    let height: number | null = null;
    let bitDepth: number | null = null;
    let horizontalDpi: number | null = null;
    let verticalDpi: number | null = null;

    const sofMarkers = new Set([
      0xC0, 0xC1, 0xC2, 0xC3,
      0xC5, 0xC6, 0xC7,
      0xC9, 0xCA, 0xCB,
      0xCD, 0xCE, 0xCF
    ]);

    while (position + 4 < bytes.length) {
      if (bytes[position] !== 0xFF) {
        position++;
        continue;
      }

      const marker = bytes[position + 1];
      position += 2;

      const isStandaloneMarker = marker === 0xD8
        || marker === 0xD9
        || marker === 0x01
        || (marker >= 0xD0 && marker <= 0xD7);

      if (isStandaloneMarker) {
        continue;
      }

      if (position + 2 > bytes.length) {
        break;
      }

      const segmentLength = view.getUint16(position, false);
      if (segmentLength < 2) {
        break;
      }

      const segmentStart = position + 2;
      const segmentEnd = position + segmentLength;
      if (segmentEnd > bytes.length) {
        break;
      }

      if (marker === 0xE0 && segmentLength >= 14) {
        const isJfif = bytes[segmentStart] === 0x4A
          && bytes[segmentStart + 1] === 0x46
          && bytes[segmentStart + 2] === 0x49
          && bytes[segmentStart + 3] === 0x46
          && bytes[segmentStart + 4] === 0x00;

        if (isJfif) {
          const densityUnits = bytes[segmentStart + 7];
          const xDensity = view.getUint16(segmentStart + 8, false);
          const yDensity = view.getUint16(segmentStart + 10, false);

          if (densityUnits === 1) {
            horizontalDpi = xDensity;
            verticalDpi = yDensity;
          } else if (densityUnits === 2) {
            horizontalDpi = Math.round(xDensity * 2.54);
            verticalDpi = Math.round(yDensity * 2.54);
          } else if (densityUnits === 0 && xDensity > 0 && yDensity > 0) {
            horizontalDpi = xDensity;
            verticalDpi = yDensity;
          }
        }
      }

      if (marker === 0xE1 && segmentLength >= 10) {
        const exifDpi = this.parseExifResolutionFromApp1(bytes.subarray(segmentStart, segmentEnd));
        if (exifDpi) {
          if (horizontalDpi == null && exifDpi.horizontalDpi != null) {
            horizontalDpi = exifDpi.horizontalDpi;
          }
          if (verticalDpi == null && exifDpi.verticalDpi != null) {
            verticalDpi = exifDpi.verticalDpi;
          }
        }
      }

      if (sofMarkers.has(marker) && segmentLength >= 8) {
        const precision = bytes[segmentStart];
        height = view.getUint16(segmentStart + 1, false);
        width = view.getUint16(segmentStart + 3, false);
        const components = bytes[segmentStart + 5];
        bitDepth = precision * components;
      }

      position = segmentEnd;
    }

    if (width == null || height == null) {
      return null;
    }

    return {
      width,
      height,
      horizontalDpi,
      verticalDpi,
      bitDepth
    };
  }

  private parseExifResolutionFromApp1(app1Data: Uint8Array): { horizontalDpi: number | null; verticalDpi: number | null } | null {
    if (app1Data.length < 14) {
      return null;
    }

    const isExif = app1Data[0] === 0x45
      && app1Data[1] === 0x78
      && app1Data[2] === 0x69
      && app1Data[3] === 0x66
      && app1Data[4] === 0x00
      && app1Data[5] === 0x00;

    if (!isExif) {
      return null;
    }

    const view = new DataView(app1Data.buffer, app1Data.byteOffset, app1Data.byteLength);
    const tiffStart = 6;

    if (tiffStart + 8 > app1Data.length) {
      return null;
    }

    const isLittleEndian = app1Data[tiffStart] === 0x49 && app1Data[tiffStart + 1] === 0x49;
    const isBigEndian = app1Data[tiffStart] === 0x4D && app1Data[tiffStart + 1] === 0x4D;
    if (!isLittleEndian && !isBigEndian) {
      return null;
    }

    const littleEndian = isLittleEndian;
    const ifd0Offset = view.getUint32(tiffStart + 4, littleEndian);
    const ifd0Start = tiffStart + ifd0Offset;

    if (ifd0Start + 2 > app1Data.length) {
      return null;
    }

    const entryCount = view.getUint16(ifd0Start, littleEndian);
    let resolutionUnit: number | null = null;
    let xResolution: number | null = null;
    let yResolution: number | null = null;

    for (let i = 0; i < entryCount; i++) {
      const entryOffset = ifd0Start + 2 + (i * 12);
      if (entryOffset + 12 > app1Data.length) {
        break;
      }

      const tag = view.getUint16(entryOffset, littleEndian);
      const type = view.getUint16(entryOffset + 2, littleEndian);
      const count = view.getUint32(entryOffset + 4, littleEndian);

      if (tag === 0x0128 && type === 3 && count >= 1) {
        resolutionUnit = view.getUint16(entryOffset + 8, littleEndian);
      } else if (tag === 0x011A && type === 5 && count === 1) {
        const valueOffset = view.getUint32(entryOffset + 8, littleEndian);
        xResolution = this.readExifRationalValue(view, tiffStart + valueOffset, littleEndian, app1Data.length);
      } else if (tag === 0x011B && type === 5 && count === 1) {
        const valueOffset = view.getUint32(entryOffset + 8, littleEndian);
        yResolution = this.readExifRationalValue(view, tiffStart + valueOffset, littleEndian, app1Data.length);
      }
    }

    if (xResolution == null && yResolution == null) {
      return null;
    }

    let horizontalDpi = xResolution;
    let verticalDpi = yResolution;

    if (resolutionUnit === 3) {
      horizontalDpi = horizontalDpi == null ? null : horizontalDpi * 2.54;
      verticalDpi = verticalDpi == null ? null : verticalDpi * 2.54;
    }

    return {
      horizontalDpi: horizontalDpi == null ? null : Math.round(horizontalDpi),
      verticalDpi: verticalDpi == null ? null : Math.round(verticalDpi)
    };
  }

  private readExifRationalValue(view: DataView, offset: number, littleEndian: boolean, dataLength: number): number | null {
    if (offset < 0 || offset + 8 > dataLength) {
      return null;
    }

    const numerator = view.getUint32(offset, littleEndian);
    const denominator = view.getUint32(offset + 4, littleEndian);
    if (denominator === 0) {
      return null;
    }

    return numerator / denominator;
  }

  private parseGifMetadata(bytes: Uint8Array): RpoImageMetadata | null {
    if (bytes.length < 13) {
      return null;
    }

    const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const width = view.getUint16(6, true);
    const height = view.getUint16(8, true);
    const packedField = bytes[10];
    const bitsPerPixel = (packedField & 0x07) + 1;

    return {
      width,
      height,
      horizontalDpi: null,
      verticalDpi: null,
      bitDepth: bitsPerPixel
    };
  }

  getBase64ImageSrc(photo) {
    if (photo == null) { return null; }
    else {
      return 'data:image/jpeg;base64,' + photo;
    }

  }
  getSliderImage() {
    this.ngxLoader.start();
    this.slides = [] as Image[]
    this.rpoService
      .getImages
      (this.ndc, this.dataSource)
      .subscribe(
        (result) => {
          if(result.data.length == 0){
            this.isEmptyImage = true;
          }
          else{
            this.isEmptyImage = false;
          }
          this.slides = [];
          result.data?.forEach((element: any) => {
            this.slides.push({
              serialImage:'data:image/png;base64,'.concat(element.serialImage),
              imageName:element.view,
              blobName: element.blobName
            })
          });
          this.ngxLoader.stop();
          this.forwardButtonLength = this.isEdit && this.dataSource == 3 ? this.slides.length : this.slides.length-1;
          this.selectedImageTypeId = 1;
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined?
            'Something went wrong!!': error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  loadAdditionalData() {
    this.ngxLoader.start();
    this.rpoService.getDrugSourceByNDC(this.ndc).subscribe(
      (response) => {
        this.listOfDataSource = response.data; 
        if (this.listOfDataSource.length > 0) {
          this.getSliderImage();
        }
        this.ngxLoader.stop();
      },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        console.log(error);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    );
  }

  onDeleteImage(blobName: string){
    this.blobName = blobName;
    this.openAlertWindowFordeleteImage();
  }

  openAlertWindowFordeleteImage() {
      const dialogRef = this.dialog.open(ImportWizardAlertComponent, {
        backdropClass: ['smDialog'],
        disableClose: true,
        data: {
          alertIcon: "/assets/img/icons/ico.16.warning.svg",
          title: "Delete Image",
          bodyMessage: "Are you sure you want to delete the image?",
          bodyMessage2: "",
          cancelBtnText: "Cancel",
          confirmBtnText: "Delete",
          confirmButtonColor: "btn-light-blue",
          cancelButtonColor: "btn-light-red",
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.data) {
          this.deleteImage()
        } else {
        }
      });
    }

    deleteImage(){
      this.ngxLoader.start();
            this.rpoService
              .deleteDrugImage(this.blobName)
              .subscribe(
                (result) => {
                  this.ngxLoader.stop();
                  if (result.statusCode === 200) {
                    this.toastService.openToast(
                      result.message,
                      constants.ToastPanelType.done,
                      2
                    );
                    this.currentIndex=0;
                    this.getSliderImage();
                  } else {
                    this.toastService.openToast(
                      result.message,
                      constants.ToastPanelType.error,
                      2
                    );
                  }
                },
                (error: HttpErrorResponse) => {
                  this.ngxLoader.stop();
                  console.log(error);
                  this.toastService.openToast(error.error.message === undefined ?
                    'Something went wrong!!' : error.error.message,
                    constants.ToastPanelType.error,
                    2
                  );
                }
              );
    }

}
